import React, {useEffect} from 'react';
import AppConfig from "../app/AppConfig";
import {useNavigate} from "react-router-dom";

const PageNotFound = () => {
  
  let navigate = useNavigate();
  
  useEffect(() => {
    if (AppConfig.isEnvLocal && AppConfig.PathDefault) {
      navigate(AppConfig.PathDefault);
    }
  }, [navigate])
  
  return (
    <div className="m10T">
      <h2 className="has-text-centered" style={{fontWeight:"bold", fontSize:"20px"}}>Página No encontrada</h2>
    </div>
  );
};

export default PageNotFound